export default __webpack_public_path__ + "static/media/BannermanBlock.8741e63b.jpg";